import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Subject } from "rxjs";
import { OnReset, Transitions } from "./transition.service.helpers";
import { doc, DocumentSnapshot, Firestore } from "@angular/fire/firestore";
import { Store } from "@ngrx/store";
import { SubscriptionHelper } from "./helpers/subscriptions.helper";
import { LogService } from "./log.service";
import { apiLink } from "../helpers/app-constants";
import { EventBackup, EventBackupBase, EventBackupsList } from "globals/store/backup.data";
import { HttpClient } from "@angular/common/http";
import { take } from "rxjs/operators";
import { JoiEvent } from "globals/store/events.data";
import { nameJoiner, subCallback } from "../helpers/helpers";
import { UserService } from "./user.service";
import { canDoBackupsReselector } from "../store/reselectors/permissions.reselector";
import { createId } from "globals/helpers/helpers";
import { backupActions } from "../store/backups.era";

@Injectable({ providedIn: 'root' })
export class BackupService implements OnReset {

  readonly _file: string = 'backup.service.ts';
  readonly api = `${environment.functionsURL}api/app`;
  
  public $backupDestroy: Subject<boolean> = new Subject()
  public $destroy: Subject<boolean> = new Subject()
  subscribedAccountIds: Set<string> = new Set()
  attempted = false

  onReset(resetType, value = null) {
    switch (resetType) {
      case Transitions.OnExitEvent: 
      this.reset()
      break
    case Transitions.OnEnterEvent:
      // console.log('subscribing to shareables...')
      // const { eventId } = value as JoiEvent
      // return this.getBackupList(eventId)
    case Transitions.OnExitUser:
      this.reset()
      break
    }

  }

  reset() {
    this.$backupDestroy.next(true)
    this.attempted = false
  }

  constructor(private db: Firestore,
    private log: LogService,
    private subscriptionHelper: SubscriptionHelper,
    private userService: UserService,
    private http: HttpClient,
    public store: Store) {    
      subCallback(this, this.store.select(canDoBackupsReselector), async(data) => {
        // console.log({ data })
        if (data && !this.attempted) {
          // console.log(data)
          this.attempted = true
          const { event } = data
          this.getBackupList(event.eventId)
        }
      })
  }

  
  async getBackupList(eventId: string) {
    const changesHandler = (changes:  DocumentSnapshot<EventBackupsList>) => {
      const backups: EventBackupBase[] = changes.data()?.backups || []
      // console.log({ changes, backups })
      this.store.dispatch(backupActions.loadBackups(backups))
    }
    this.subscriptionHelper.subscribeToDocumentSnapshotChanges(doc(this.db, `backups/${eventId}`), 
      changesHandler.bind(this), this.$backupDestroy, this._file, 'getBackup')
  }

  async makeBackup(event: JoiEvent, name: string) {
    const url = `${apiLink}/create-backup`;
    const { eventId, accountId } = event
    const eventBackupBase: EventBackupBase = {
      eventId,
      accountId,
      name,
      id: createId(),
      date: new Date().getTime(),
      creator: nameJoiner(this.userService),
      type: 'User'
    }
    console.log({ eventBackupBase })
    const backup = await this.http.post(url, { eventBackupBase }).pipe(take(1)).toPromise() as EventBackup
    console.log({ backup })
    return backup
  }

  async loadBackup(eventBackupBase: EventBackupBase) {
    const url = `${apiLink}/load-backup`;
    const backup = await this.http.post(url, { eventBackupBase }).pipe(take(1)).toPromise() as EventBackup
    console.log({ backup })
    return backup
  }

  async deleteBackup(eventBackupBase: EventBackupBase) {
    const url = `${apiLink}/delete-backup`;
    await this.http.post(url, { eventBackupBase }).pipe(take(1)).toPromise()
  }

  async restoreBackup(eventBackupBase: EventBackupBase) {
    const url = `${apiLink}/restore-backup`;
    await this.http.post(url, { eventBackupBase }).pipe(take(1)).toPromise()
  }

}
